/**
 * Simple reactive store for YouTube API status
 * This allows components to share the YouTube API status across the app
 */
import { reactive } from 'vue';

export const youtubeStatus = reactive({
  hasError: false,
  isLoading: false,
  errorType: null, // 'quota', 'network', 'api', etc.
  lastChecked: null,
  
  // Methods to update status
  setError(errorType = 'unknown') {
    this.hasError = true;
    this.isLoading = false;
    this.errorType = errorType;
    this.lastChecked = new Date();
  },
  
  setLoading(loading = true) {
    this.isLoading = loading;
    if (loading) {
      this.hasError = false;
      this.errorType = null;
    }
  },
  
  setSuccess() {
    this.hasError = false;
    this.isLoading = false;
    this.errorType = null;
    this.lastChecked = new Date();
  },
  
  reset() {
    this.hasError = false;
    this.isLoading = false;
    this.errorType = null;
    this.lastChecked = null;
  }
});
